import React from "react";

// MUI
import MuiLink from "@mui/material/Link";

// MUI Icons
import LinkIcon from '@mui/icons-material/Link';

// Styles
import styles from "./style.module.scss";

// Types
import { Link } from "../../../types";

interface LinkPreviewProps {
  link: Link;
}

const LinkPreview: React.FC<LinkPreviewProps> = ({ link }) => {

  return (
    <div className={styles.root}>
      <div className={styles.icon_container}>
        <LinkIcon className={styles.icon} color="primary" />
      </div>

      <MuiLink href={link.url} target='_blank' rel='noopener noreferrer'>
        {link.url}
      </MuiLink>
    </div>
  )
}

export default LinkPreview;
